import React, { Component } from "react";
import Header from "../components/Header";
import { Dialog } from "@progress/kendo-react-dialogs";
import InventorySetRulePage from "./InventorySetRulePage";
import InventoryDeleteRulePage from "./InventoryDeleteRulePage";
import {
    GridColumn as Column,
    GridDetailRow
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
    GoalMetCell,
    EditCell,
    DeleteCell,
    PercentCell,
    DateCell,
    BlankCell
} from "../components/utils/GridHelpers";
import { AppContext } from "../context/AppContext";

import isPage from "../hoc/isPage";
import GridContainer, { GridContainerToolbar, GridContainerToolbarOption } from '../components/GridContainer';

import { getExportFileName } from "../helpers";
import localize from "../hoc/localize";


class DetailComponent extends GridDetailRow {
    render() {
        const data = this.props.dataItem;

        const roiResultColumn = (
            <Column
                field="roiResult"
                title={this.props.returnLocalizedString("m0199")}
                className="numeric"
                headerClassName="numeric"
                width="200px"
                cell={props => <PercentCell {...props} />}
            />
        );

        const specialOrderResultColumn = (
            <Column
                field="specialOrderResult"
                title={this.props.returnLocalizedString("m0199")}
                className="numeric padRight"
                width="200px"
                headerClassName="numeric padRight" />
        );

        if (data.details) {
            return (
                <div className="detail-grid">
                    <GridContainer data={data.details}>
                        <Column field="dealer" title={this.props.returnLocalizedString("m0200")} />

                        {this.props.dataItem.roiTarget ? (
                            <Column
                                title={this.props.returnLocalizedString("m0201", "", this.props.dataItem.roiTarget)}
                            >
                                <Column
                                    field="roiGoalMet"
                                    title={this.props.returnLocalizedString("m0202")}
                                    cell={props => (
                                        <GoalMetCell
                                            mode="checkbox"
                                            {...props}
                                        />
                                    )}
                                    width="150px"
                                />
                                {roiResultColumn}
                            </Column>
                        ) : (
                                <Column title={this.props.returnLocalizedString("m0203")} width="100px">
                                    {roiResultColumn}
                                </Column>
                            )}

                        {this.props.dataItem.specialOrderTarget ? (
                            <Column
                                title={this.props.returnLocalizedString("m0204", "", 
                                    this.props.dataItem.specialOrderTarget)}
                            >
                                <Column
                                    field="specialOrderGoalMet"
                                    title={this.props.returnLocalizedString("m0202")}
                                    cell={props => (
                                        <GoalMetCell
                                            mode="checkbox"
                                            {...props}
                                        />
                                    )}
                                    width="150px"
                                />
                                {specialOrderResultColumn}
                            </Column>
                        ) : (
                                <Column
                                    title={this.props.returnLocalizedString("m0205")}
                                    width="200px"
                                >
                                    {specialOrderResultColumn}
                                </Column>
                            )}
                        <Column
                            cell={(props) => (
                                <BlankCell {...props} />
                            )}
                        />
                    </GridContainer>
                </div>
            );
        }

        return (
            <div style={{ height: "50px", width: "100%" }}>
                <div style={{ position: "absolute", width: "100%" }}>
                    <div className="k-loading-image" />
                </div>
            </div>
        );
    }
}

class InventoryShapingPage extends Component {
    _export;
    //constructor(props) {
    //    super(props);
    //}

    state = {
        inventoryShapingData: null,
        // showEditRuleModal: true,
        // editedRuleID: 1, // ID for the selected rule
        showEditRuleModal: false,
        editedRuleID: null, // ID for the selected rule
        showDeleteRuleModal: false,
        rules: null, // an array of rules
        sort: [
            {
                field: "partNumber",
                dir: "asc"
            }
        ]
    };

    componentDidMount() {
        if (this.hasNecessaryParameters()) {
            this.getData();
        }
    }

    // handles clicking the delete button in the table row
    handleDelete = ruleID => {
        this.setState({
            showDeleteRuleModal: true,
            editedRuleID: ruleID
        });
    };

    // handle the Create New Rule button click
    handleOpenModal = () => {
        this.setState({ showEditRuleModal: true, editedRuleID: null });
    };

    // handle clicking the edit button in the table row
    handleEdit = ruleID => {
        //debugger;
        //const selectedRule = this.state.inventoryShapingData.find((rule) => ruleId);

        // get all the data for the selected rule

        this.setState({
            showEditRuleModal: true,
            editedRuleID: ruleID
        });
    };

    handleCloseModal = () => {
        this.setState({
            showEditRuleModal: false,
            showDeleteRuleModal: false
        });
    };

    expandChange = e => {
        e.dataItem.expanded = !e.dataItem.expanded;
        this.forceUpdate();
    };

    // export the data into an Excel sheet
    export = () => {
        this._export.save(this.state.rules);
    };

    // check if we have necessary parameters to do a data request
    // if chose a dealership org type, then must have chosen a dealership
    // same for report group
    hasNecessaryParameters = () => {
        const orgType = this.context.state.inventoryShapingSelectedOrgType;
        let org = this.context.state.inventoryShapingSelectedOrg;
        let reportGroup = this.context.state
            .inventoryShapingSelectedReportGroup;


        return (
            (orgType === "dealership" && org) ||
            (orgType === "reportGroup" && reportGroup)
        );
    };

    getData = () => {
        const orgType = this.context.state.inventoryShapingSelectedOrgType;
        let org = this.context.state.inventoryShapingSelectedOrg;
        let reportGroup = this.context.state
            .inventoryShapingSelectedReportGroup;

        // once we've selected either a dealer or a report group, then let's grab the data
        if (org || reportGroup) {
            // set up additional filters to append to API endpoint querystring
            let endpointQuerystring = "";

            if (orgType === "dealership" && org) {
                endpointQuerystring = `orgID=${org.orgID}`;
            } else if (orgType === "reportGroup" && reportGroup) {
                endpointQuerystring = `reportGroupID=${
                    reportGroup.reportGroupID
                    }`;
            } else {
                this.setState({ rules: null });
                return;
            }

            const apiUrl = `/api/portal/inventory/shapingRule/GetList?${endpointQuerystring}`;

            this.props
                .getData(apiUrl)
                .then(response => {
                    this.setState({ rules: response.data });


                })
                .catch(error => {
                    this.setState({ rules: null });
                    this.props.alert(
                        "error",
                        this.props.returnLocalizedString("m0023"),
                        this.props.returnLocalizedString("m0206")
                    );
                });
        }
    };

    handleChange = e => {

        this.context.setState(
            {
                [e.target.name]: e.target.value
            },
            () => {
                this.setState({
                    rules: null
                });
                if (this.hasNecessaryParameters()) {
                    this.getData();
                }
            }
        );
    };

    handleRefreshListing = () => {
        // reload the data
        if (this.hasNecessaryParameters()) {
            this.getData();
        }
    };

    render() {

        //!DBTRANS! @m0008@ Report Group !DEVNOTE! Column name
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status 
        //!DBTRANS! @m0191@ Part Number !DEVNOTE! Column Name
        //!DBTRANS! @m0199@ Actual !DEVNOTE! Column Name
        //!DBTRANS! @m0200@ Dealer Name  !DEVNOTE! Column Name
        //!DBTRANS! @m0201@ ROI Target: ≥ %var1% %!DEVNOTE! Column Name
        //!DBTRANS! @m0202@ Goal Met?  !DEVNOTE! Input label
        //!DBTRANS! @m0203@ No ROI target set  !DEVNOTE! Input label
        //!DBTRANS! @m0204@ Special Order Target: ≤ %var1% % !DEVNOTE! Input label
        //!DBTRANS! @m0205@ No Special Order target set  !DEVNOTE! Action status 
        //!DBTRANS! @m0206@ Unable to retrieve the list of shaping rules.  !DEVNOTE! Action status 
        //!DBTRANS! @m0207@ Inventory Shaping !DEVNOTE! Label
        //!DBTRANS! @m0208@ Showing your order shaping rules by !DEVNOTE! Table label
        //!DBTRANS! @m0209@ Single dealer !DEVNOTE! 
        //!DBTRANS! @m0210@ Choose a report group !DEVNOTE! Button label
        //!DBTRANS! @m0211@ Choose a dealership !DEVNOTE! Button label
        //!DBTRANS! @m0212@ Create new rule !DEVNOTE! Button label
        //!DBTRANS! @m0213@ Current Threshold !DEVNOTE! 
        //!DBTRANS! @m0214@ ROI Goal Met !DEVNOTE!
        //!DBTRANS! @m0215@ Special Order Goal Met !DEVNOTE!
        //!DBTRANS! @m0216@ Active For !DEVNOTE!
        //!DBTRANS! @m0217@ Effective Date !DEVNOTE!
        //!DBTRANS! @m0218@ Expiry Date !DEVNOTE!
        //!DBTRANS! @m0219@ Delete Rule !DEVNOTE! Button label

        return (
            <AppContext.Consumer>
                {context => (
                    <div>
                        <Header title={this.props.returnLocalizedString("m0207")} />

                        <section className="page-content grid-row pad-it">
                            <div className="search-panel-rules">
                                {/*Showing your order shaping rules by &nbsp;
								<DealershipFilter
									filterType="both"
									handleChange={this.handleChange}
								/>*/}
                                {this.props.returnLocalizedString("m0208")} &nbsp;
								<span className="choices">
                                    <input
                                        checked={
                                            context.state
                                                .inventoryShapingSelectedOrgType &&
                                            context.state
                                                .inventoryShapingSelectedOrgType ===
                                            "reportGroup"
                                        }
                                        type="radio"
                                        name="inventoryShapingSelectedOrgType"
                                        id="groupFilter"
                                        defaultValue="reportGroup"
                                        onChange={this.handleChange}
                                        className="k-radio"
                                        required="required"
                                    />

                                    <label
                                        htmlFor="groupFilter"
                                        className="k-radio-label"
                                    >
                                        {this.props.returnLocalizedString("m0008")}
									</label>

                                    <input
                                        checked={
                                            context.state
                                                .inventoryShapingSelectedOrgType &&
                                            context.state
                                                .inventoryShapingSelectedOrgType ===
                                            "dealership"
                                        }
                                        type="radio"
                                        name="inventoryShapingSelectedOrgType"
                                        id="singleFilter"
                                        defaultValue="dealership"
                                        onChange={this.handleChange}
                                        className="k-radio"
                                    />

                                    <label
                                        htmlFor="singleFilter"
                                        className="k-radio-label"
                                    >
                                        {this.props.returnLocalizedString("m0209")}
									</label>
                                </span>
                                <div className="bottom-margin-10">
                                    <span
                                        className={
                                            context.state
                                                .inventoryShapingSelectedOrgType !==
                                                "reportGroup"
                                                ? "hidden"
                                                : ""
                                        }
                                    >
                                        <DropDownList
                                            data={context.state.reportGroups}
                                            textField="reportGroupName"
                                            dataItemKey="reportGroupID"
                                            name="inventoryShapingSelectedReportGroup"
                                            value={
                                                context.state
                                                    .inventoryShapingSelectedReportGroup
                                            }
                                            onChange={this.handleChange}
                                            label={this.props.returnLocalizedString("m0210")}
                                        />
                                    </span>

                                    <span
                                        className={
                                            context.state
                                                .inventoryShapingSelectedOrgType !==
                                                "dealership"
                                                ? "hidden"
                                                : ""
                                        }
                                    >
                                        <DropDownList
                                            data={
                                                context.state.childDealerships
                                            }
                                            textField="orgName"
                                            dataItemKey="orgID"
                                            name="inventoryShapingSelectedOrg"
                                            value={
                                                context.state
                                                    .inventoryShapingSelectedOrg
                                            }
                                            onChange={this.handleChange}
                                            label={this.props.returnLocalizedString("m0211")}
                                        />
                                    </span>
                                </div>
                            </div>

                            {this.state.rules && (

                                <GridContainer
                                    data={this.state.rules}
                                    sortColumn="partNumber"

                                    detail={localize(DetailComponent)}
                                    onExpandChange={this.expandChange}

                                    excelFilename={getExportFileName("inventory-shaping-rules")}
                                >
                                    <GridContainerToolbar>
                                        <GridContainerToolbarOption type="add" tooltip="m0212" handleClick={this.handleOpenModal} />
                                    </GridContainerToolbar>

                                    <Column
                                        title={this.props.returnLocalizedString("m0191")}
                                        field="partNumber"
                                        width="150px"
                                    />
                                    <Column
                                        title={this.props.returnLocalizedString("m0213")}
                                        field="threshold"
                                        width="200px"
                                    />
                                    <Column
                                        field="roiGoalMet"
                                        title={this.props.returnLocalizedString("m0214")}
                                        width="150px"
                                        cell={props => (
                                            <GoalMetCell
                                                mode="checkbox"
                                                {...props}
                                            />
                                        )}
                                    />
                                    <Column
                                        field="specialOrderGoalMet"
                                        title={this.props.returnLocalizedString("m0215")}
                                        width="225px"
                                        cell={props => (
                                            <GoalMetCell
                                                mode="checkbox"
                                                {...props}
                                            />
                                        )}
                                    />
                                    {/*
                                    <Column
                                        field="activeFor"
                                        title={this.props.returnLocalizedString("m0216")}
                                        width="150px"
                                    />*/}
                                    <Column
                                        field="effectiveDate"
                                        title={this.props.returnLocalizedString("m0217")}
                                        width="150px"
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="expiryDate"
                                        title={this.props.returnLocalizedString("m0218")}

                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width="150px"
                                    />
                                    <Column
                                        width="40px"
                                        cell={props => (
                                            <EditCell
                                                dataItemKey="ruleId"
                                                handleEdit={
                                                    this.handleEdit
                                                }
                                                {...props}
                                            />
                                        )}
                                    />
                                    <Column
                                        width="40px"
                                        cell={props => (
                                            <DeleteCell
                                                dataItemKey="ruleId"
                                                handleDelete={
                                                    this.handleDelete
                                                }
                                                {...props}
                                            />
                                        )}
                                    />
                                    <Column
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>

                            )}

                            {this.state.showEditRuleModal && (
                                <Dialog
                                    onClose={this.handleCloseModal}
                                    width={"60%"}
                                    minWidth={320}
                                    closeIcon={false}
                                >
                                    <InventorySetRulePage
                                        ruleID={this.state.editedRuleID}
                                        orgID={
                                            context.state
                                                .inventoryShapingSelectedOrgType ===
                                                "dealership"
                                                ? context.state
                                                    .inventoryShapingSelectedOrg
                                                    .orgID
                                                : undefined
                                        }
                                        reportGroupID={
                                            context.state
                                                .inventoryShapingSelectedOrgType ===
                                                "reportGroup"
                                                ? context.state
                                                    .inventoryShapingSelectedReportGroup
                                                    .reportGroupID
                                                : undefined
                                        }
                                        handleCloseModal={this.handleCloseModal}
                                        handleRefreshListing={
                                            this.handleRefreshListing
                                        }
                                    />
                                </Dialog>
                            )}

                            {this.state.showDeleteRuleModal && (
                                <Dialog
                                    title={this.props.returnLocalizedString("m0219")}
                                    onClose={this.handleCloseModal}
                                    width={"25%"}
                                    minWidth={320}
                                >
                                    <InventoryDeleteRulePage
                                        ruleID={this.state.editedRuleID}
                                        handleCloseModal={this.handleCloseModal}
                                        handleRefreshListing={
                                            this.handleRefreshListing
                                        }
                                    />
                                </Dialog>
                            )}
                        </section>
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}

export default isPage(InventoryShapingPage);
InventoryShapingPage.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/InventoryShapingPage.js